const LoginJules = ({ className = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 857 1024"
    >
      <path
        fill="#1F2937"
        d="M0 366.5C0 164.088 164.088 0 366.5 0S733 164.088 733 366.5V1023H0V366.5z"
      />
      <path
        stroke="#6366F1"
        strokeLinecap="round"
        strokeWidth="67.639"
        d="M555.046 616.928C652 632 787 533 757.5 408.5"
      />
      <path
        fill="#D1D5DB"
        d="M277.213 540.285l-50.088 38.887 225.551 290.509 88.975 11.199-264.438-340.595z"
      />
      <path
        fill="#9CA3AF"
        d="M277.212 540.285l50.087-38.887 225.55 290.508-11.199 88.975-264.438-340.596z"
      />
      <rect
        width="202.917"
        height="46.502"
        fill="#312E81"
        rx="4.227"
        transform="scale(1 -1) rotate(37.826 977.78 -13.664)"
      />
      <path
        fill="#312E81"
        d="M233.098 531.719l46.748-36.296-75.183-96.836c-10.023-12.909-28.613-15.249-41.522-5.226-12.909 10.022-15.249 28.612-5.227 41.522l75.184 96.836z"
      />
      <ellipse
        fill="#6366F1"
        rx="107.8"
        ry="103.572"
        transform="matrix(-1 0 0 1 489.957 428.497)"
      />
      <path
        fill="#fff"
        d="M563.939 430.611c0 5.606-3.34 10.982-9.286 14.946-5.946 3.964-14.011 6.191-22.42 6.191-8.409 0-16.473-2.227-22.419-6.191-5.946-3.964-9.287-9.34-9.287-14.946h63.412z"
      />
      <ellipse
        fill="#1F2937"
        rx="16.91"
        ry="19.023"
        transform="matrix(-1 0 0 1 586.266 424.271)"
      />
      <ellipse
        fill="#1F2937"
        rx="16.91"
        ry="19.023"
        transform="matrix(-1 0 0 1 487.844 424.271)"
      />
      <path
        fill="#4338CA"
        d="M439.042 566.341c40.02 18.863 78.734 11.845 103.413 1.243 9.059-3.892 20.484.391 23.036 9.915l114.665 428.031c2.421 9.03-4.414 17.9-13.77 17.86l-374.191-1.69c-9.603-.04-16.39-9.41-13.437-18.55l138.376-428.207c2.876-8.902 13.445-12.591 21.908-8.602z"
      />
      <path
        stroke="#312E81"
        strokeLinecap="round"
        strokeWidth="8.455"
        d="M525.13 578.454s46.824 193.584 60.525 436.456"
      />
      <ellipse
        fill="#312E81"
        rx="12.68"
        ry="14.53"
        transform="matrix(-.99461 .10365 .10764 .99419 505.149 651.067)"
      />
      <ellipse
        fill="#312E81"
        rx="12.68"
        ry="14.53"
        transform="matrix(-.99461 .10365 .10764 .99419 515.595 737.808)"
      />
      <path
        fill="#4F46E5"
        d="M544.136 219.735l23.069 116.278c2.098 10.579-10.59 17.644-18.477 10.287l-80.079-74.694a46.453 46.453 0 00-30.34-12.463l-67.442-1.952c-34.17-.989-61.049-29.524-59.996-63.692 1.069-34.667 30.447-61.67 65.082-59.82l73.43 3.924c46.648 2.492 85.663 36.31 94.753 82.132z"
      />
      <path
        stroke="#3730A3"
        strokeLinecap="round"
        strokeWidth="7.423"
        d="M402.3 224.909c-4.511-3.896-16.522-9.726-28.482-1.881"
      />
      <path
        fill="#3730A3"
        d="M393.835 458.375c-8.625 4.894-20.484-1.777-21.357-11.655-2.812-31.796-8.699-83.001-3.205-94.127a125.829 125.829 0 01168.529-57.113 125.817 125.817 0 0163.46 72.436 125.823 125.823 0 016.588 36.227c.228 6.876-5.77 12.084-12.635 11.63l-109.398-7.226a12.454 12.454 0 00-6.968 1.596l-85.014 48.232z"
      />
      <path
        fill="#6366F1"
        d="M384.328 244.98l22.471 113.267c2.718 13.7-12.485 23.847-24.094 16.081l-76.77-51.351a53.931 53.931 0 00-40.482-8.074l-41.2 8.173c-39.982 7.932-78.824-18.05-86.756-58.032-7.932-39.982 18.05-78.824 58.032-86.756l68.716-13.633c55.341-10.978 109.104 24.984 120.083 80.325z"
      />
      <path
        stroke="#3730A3"
        strokeLinecap="round"
        strokeWidth="7.423"
        d="M326.347 219.892c-4.511-3.895-16.522-9.726-28.482-1.881M231.095 218.368c-4.511-3.895-16.522-9.726-28.482-1.881M280.49 264.54c-4.51-3.896-16.521-9.726-28.482-1.881M217.519 279.452c-4.51-3.896-16.521-9.726-28.481-1.882M359.308 298.351c-4.511-3.895-16.522-9.726-28.482-1.881M461.772 190.695c-4.51-3.895-16.521-9.726-28.482-1.881M492.18 235.612c-4.511-3.895-16.522-9.726-28.482-1.881M396.569 167.317c-4.51-3.895-16.521-9.726-28.482-1.881"
      />
      <path
        fill="#4338CA"
        d="M856.473 678l-36.902-97.803c-4.103-10.875-18.065-13.884-26.284-5.666l-120.809 120.81a16 16 0 00-3.641 17.003l42.154 110.792L856.473 678z"
      />
      <path
        fill="#E0E7FF"
        d="M804.473 595.5l37 91-37 8.5-91.5-91.5c32.8-26.8 74.666-16.5 91.5-8z"
      />
      <path
        fill="#818CF8"
        d="M810.973 680.309l-90.51-90.51c-10.935-10.935-28.663-10.935-39.598 0L574.902 695.762c-10.975 10.975-10.929 28.783.102 39.7L665.473 825l145.5-144.691z"
      />
      <path
        fill="#818CF8"
        d="M854.542 679.12l1.931-1.12-143.5 144-4.187 3.381c-12.675 10.238-30.821 10.078-43.313-.381l143-146a45.706 45.706 0 0046.069.12z"
      />
      <path
        stroke="#6366F1"
        strokeLinecap="round"
        strokeWidth="67.639"
        d="M643.5 734S401 817.5 401 622"
      />
    </svg>
  );
};

export default LoginJules;
